import styled from 'styled-components';

export const StyledLoadingPage = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  min-height: inherit;
`;
